module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-7.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I",
    attrs: {
      "id": "toc_marker-8"
    }
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("“ . . . Never tell all you feel, or (a better way still), feel very little . . ."), _c('br'), _vm._v("at any rate never have any feelings which may make you "), _c('br'), _vm._v("uncomfortable, or make any promises which you cannot at any ")]), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("required moment command and withdraw. That is the way to get on . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("William Makepeace Thackeray: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Vanity Fair")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_c('span', {
    staticClass: "char-style-override-11"
  }, [_vm._v("1847")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-8"
  }, [_vm._v("“Wer spricht von Siegen? Überstehen ist Alles.”")]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("Rainer Maria Rilke: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Requiem, für Wolf Graf von Kalckreuth")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_c('span', {
    staticClass: "char-style-override-11"
  }, [_vm._v("1908")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-8"
  }, [_vm._v("“The warriors are dead. The warriors died in two world wars. "), _c('br'), _vm._v("Those who remain are the barterers. They know the price of "), _c('br'), _vm._v("coffee and cocoa and sugar and flour in a defeated country.”")]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("Kay Boyle: "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The Lovers of Gain")])]), _vm._v(" "), _c('p', {
    staticClass: "P-Epi-02 para-style-override-10"
  }, [_vm._v("1950")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-049a9f7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epub42117.vue
// module id = 81
// module chunks = 0